/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React, {PureComponent} from 'react';
import YtDownload from "./ytDownload";
import {downloadUrl} from "../../util/requestSender";
import {downloadFile, ResponseData, showDialog} from '@dvrd/dvr-controls';

interface State {
    url: string;
    loading: boolean;
}

export default class YtDownloaderController extends PureComponent<any, State> {
    state: State = {
        url: '',
        loading: false,
    };

    onChangeUrl = (url: string) => {
        this.setState({url});
    }

    onDownload = () => {
        const {url} = this.state;
        if (url.length) {
            this.setState({loading: true});
            downloadUrl({
                data: {url}, callback: (response: ResponseData | Response) => {
                    this.setState({loading: false});
                    if (response instanceof Response) {
                        // FILE RESPONSE
                        const header = response.headers.get('Content-Disposition');
                        let fileName = 'yt-download.mp3';
                        if (header)
                            fileName = header.substr(header.indexOf('filename=') + 'filename='.length, header.length);
                        response.blob().then(blob => {
                            downloadFile(blob, fileName);
                        });
                    } else
                        // ERROR RESPONSE
                        showDialog(response.message || 'Het downloaden van de muziek is niet gelukt.',
                            'Exporteren mislukt');
                }
            });
        }
    };

    render = () => {
        const {url, loading} = this.state;
        return <YtDownload onChangeUrl={this.onChangeUrl} onDownload={this.onDownload} url={url} loading={loading}/>
    };
}